export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "highlight_worker.3a350d57.worker.js");
}
